var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fourSymbolsLineDiagram"},[_c('div',{staticClass:"ElephantLine",attrs:{"id":'ElephantLine_' + _vm.id_type}})])
}
var staticRenderFns = []

export { render, staticRenderFns }